export default __webpack_public_path__ + "static/Design-prototipo-navegavel-167936cc905e93de4a7378624ff40ea7.png";